import * as React from 'react';
import styles from './InfoProperty.module.sass';

export interface IProps {
	children?: any;
	title: string;
}

export default function InfoProperty(props: IProps) {
	return (
		<div className={styles.deviceInfo}>
			<span className={styles.deviceInfoLabel}>{props.title}</span>
			<span>{props.children}</span>
		</div>
	);
}
